import request from '@/request/request'
let baseURL =  global.$config.api.system_url + '/emergency-server/'
// 新增通讯设备
export function save(data) {
    return request({
        baseURL,
        url: '/emergencyCommunication/save',
        method: 'post',
        data
    })
}
//修改通讯设备
export function update(data) {
    return request({
        baseURL,
        url: '/emergencyCommunication/update',
        method: 'post',
        data
    })
}
//查询通讯设备列表
export function list(params) {
    return request({
        baseURL,
        url: '/emergencyCommunication/list',
        method: 'get',
        params
    })
}
//查询通讯设备
export function detail(id) {
    return request({
        baseURL,
        url: '/emergencyCommunication/detail?id=' + id,
        method: 'get',
    })
}
//删除通讯设备
export function remove(data) {
    return request({
        baseURL,
        url: '/emergencyCommunication/remove',
        method: 'post',
        data: { ...data, isFormData:true }
    })
}